<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Solicitações</b>
                        </h3>
                    </div>
                    <div class="box-body">
                        <div class="nav-tabs-custom">
                            <ul class="nav nav-tabs">
                                <li class="active"><a href="#tab_1" data-toggle="tab">Em análise</a></li>
                                <li><a href="#tab_2" data-toggle="tab">Reguladas do dia</a></li>
                                <li><a href="#tab_3" data-toggle="tab">Negativadas do dia</a></li>
                                <!-- <li><a href="#tab_4" data-toggle="tab">Com informações adicionais</a></li> -->
                            </ul>
                        </div>
                        <div class="tab-content">
                            <div class="tab-pane active" id="tab_1">
                                <tabelaSolicitacoes :situacao="[SITUACAO_SOLICITACAO.EM_REGULACAO, SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL]"></tabelaSolicitacoes>
                            </div>
                            <div class="tab-pane" id="tab_2">
                                <tabelaSolicitacoes :situacao="[SITUACAO_SOLICITACAO.REGULADA]"></tabelaSolicitacoes>
                            </div>
                            <div class="tab-pane" id="tab_3">
                                <tabelaSolicitacoes :situacao="[SITUACAO_SOLICITACAO.NEGATIVADA]"></tabelaSolicitacoes>
                            </div>
                            <!--
							<div class="tab-pane" id="tab_4">
                                <tabelaSolicitacoes :situacao="[SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL]"></tabelaSolicitacoes>
                            </div>
                            -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import TabelaSolicitacoes from "./tabelaSolicitacoes";
import { SITUACAO_SOLICITACAO } from "@/constants";

export default {
    computed: {
        SITUACAO_SOLICITACAO: function() {
            return SITUACAO_SOLICITACAO;
        }
    },
    data: () => ({}),
    mounted() {},
    methods: {},
    watch: {},
    components: { TabelaSolicitacoes }
};
</script>
<style>
.v-select .dropdown-toggle {
    padding: 0 !important;
    border-radius: 0px !important;
}

.v-select input[type="search"] {
    margin: 0 0 0 !important;
}

.v-select .selected-tag {
    margin: 5px !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?242c94f1